import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const TokenDistributionChart = () => {
  const data = {
    labels: [
      'Sponsor Pool 1 (40%)',
      'Sponsor Pool 2 (40%)',
      'Development (10%)',
      'Marketing (5%)',
      'Liquidity Pool (5%)'
    ],
    datasets: [
      {
        data: [40, 40, 10, 5, 5],
        backgroundColor: [
          '#007BFF', // Primary blue
          '#28A745', // Secondary green
          '#FFC107', // Yellow
          '#DC3545', // Red
          '#6C757D'  // Gray
        ],
        borderColor: '#FFFFFF',
        borderWidth: 2
      }
    ]
  };

  const options: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          font: {
            size: 14
          }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed || 0;
            return `${label}: ${value}%`;
          }
        }
      }
    }
  };

  return (
    <div className="h-[400px] w-full">
      <Pie data={data} options={options} />
    </div>
  );
};

export default TokenDistributionChart;